import subCategoryStore from 'js/stores/store';
import subCategoryActions from 'js/actions/actions';
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import copy from 'copy-to-clipboard';

//React Router
import React, { useState } from 'react';

const downloadOptions = [
  { extension: '.png', text: 'PNG 16', color: '#3498DB ', size: 16 },
  { extension: '.png', text: 'PNG 32', color: '#3498DB ', size: 32 },
  { extension: '.png', text: 'PNG 64', color: '#3498DB ', size: 64 },
  { extension: '.png', text: 'PNG 256', color: '#3498DB ', size: 256 },
  { extension: '.svg', text: 'SVG 256', color: '#ff8533 ', size: 256 }
];

const useStyles = makeStyles(theme => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 200
  }
}));

function IconGroups(props) {
  const classes = useStyles();
  const { subPack } = props;
  const { groups: allGroups, icons } = subPack;

  const groups = {};
  Object.keys(allGroups).forEach(key => {
    const groupIds = allGroups[key].details.map(icon => icon.id);
    if (icons.some(icon => groupIds.includes(icon.id))) {
      groups[key] = allGroups[key];
    }
  });

  const iconTypeState = {};
  const fileTypeState = {};
  const iconForThumbnail = {};
  Object.keys(groups).map(key => {
    const [iconValue, setIconValue] = React.useState('');
    iconTypeState[key] = [iconValue, setIconValue];
    const [fileValue, setFileValue] = React.useState('');
    fileTypeState[key] = [fileValue, setFileValue];
    const [iconThumbValue, setIconThumbValue] = React.useState('');
    iconForThumbnail[key] = [iconThumbValue, setIconThumbValue];
  });

  const [copied, setCopied] = React.useState(false);

  const inputLabel = React.useRef(null);
  const [labelWidth, setLabelWidth] = React.useState(0);
  React.useEffect(() => {
    setLabelWidth(inputLabel.current.offsetWidth);
  }, []);

  const handleIconTypeChange = (key, value) => {
    iconTypeState[key][1](value);

    let thumbnailValue = '';
    if (value === '' || value === 'all' || value === undefined) {
      thumbnailValue = groups[key].details[0].path;
    } else {
      const icon = groups[key].details.find(icon => {
        return icon.id === value;
      });
      thumbnailValue = icon.path;
    }

    iconForThumbnail[key][1](thumbnailValue);
  };
  const handleFileTypeChange = (key, value) => {
    fileTypeState[key][1](value);
  };

  function copyURL(subPack, category) {
    const baseUrl = subCategoryStore.getState().symbologyJson.meta.s3_root_url;
    const iconType = iconTypeState[category][0];
    const fileType = fileTypeState[category][0];
    const downloadOption = downloadOptions.find(option => {
      return option.text === fileType;
    });
    const updateURL = path => {
      return (
        path.slice(0, path.lastIndexOf('_')) +
        '_' +
        downloadOption.size +
        'x' +
        downloadOption.size +
        downloadOption.extension
      );
    };
    const icon = icons.find(icon => {
      return icon.id === iconType;
    });
    const iconPath = updateURL(icon.path);
    const url = 'https:' + baseUrl + iconPath;
    gtag('event', 'Group Icons Copied', {
      event_category: 'URL Copied',
      event_label: iconPath
    });
    copy(url);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 1500);
  }

  function updateIcon(subPack, category, groupIcons) {
    const iconType = iconTypeState[category][0];
    const fileType = fileTypeState[category][0];
    const downloadOption = downloadOptions.find(option => {
      return option.text === fileType;
    });
    const updateURL = path => {
      return (
        path.slice(0, path.lastIndexOf('_')) +
        '_' +
        downloadOption.size +
        'x' +
        downloadOption.size +
        downloadOption.extension
      );
    };

    if (iconType !== 'all') {
      const icon = icons.find(icon => {
        return icon.id === iconType;
      });
      const updateItem = JSON.parse(JSON.stringify(icon));
      updateItem.path = updateURL(icon.path);
      subCategoryActions.updateMyIcons({ item: updateItem, isAdd: true });
    } else {
      groupIcons.details.forEach(groupIcon => {
        const icon = icons.find(icon => {
          return icon.id === groupIcon.id;
        });
        const updateItem = JSON.parse(JSON.stringify(icon));
        updateItem.path = updateURL(icon.path);
        subCategoryActions.updateMyIcons({ item: updateItem, isAdd: true });
      });
    }
  }

  return (
    <div className='icon-group-container'>
      {Object.entries(groups).map(([key, value]) => {
        // console.log(key, value);
        const iconForImg = value.details[0];
        return (
          <div className='flex subcategory--list icon-group-row'>
            <div style={{ padding: '15px', maxWidth: '350px' }}>{key}</div>
            <div style={{ display: 'flex', flexGrow: 1 }} />
            <div>
              <div
                id={iconForImg.id + '-image-container'}
                className='subcategory--list--item relative'
              >
                <img
                  src={
                    subCategoryStore.getState().symbologyJson.meta.s3_root_url +
                    (iconForThumbnail[key][0] || iconForImg.path)
                  }
                />
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <FormControl variant='outlined' className={classes.formControl}>
                <InputLabel
                  ref={inputLabel}
                  id='demo-simple-select-outlined-label'
                >
                  Select File Type
                </InputLabel>
                <Select
                  labelId='demo-simple-select-outlined-label'
                  id='demo-simple-select-outlined'
                  value={fileTypeState[key][0]}
                  onChange={evt => {
                    handleFileTypeChange(key, evt.target.value);
                  }}
                  labelWidth={labelWidth}
                >
                  {downloadOptions.map(type => {
                    return <MenuItem value={type.text}>{type.text}</MenuItem>;
                  })}
                </Select>
              </FormControl>
              <FormControl variant='outlined' className={classes.formControl}>
                <InputLabel
                  ref={inputLabel}
                  id='demo-simple-select-outlined-label'
                >
                  Select Icon Type
                </InputLabel>
                <Select
                  labelId='demo-simple-select-outlined-label'
                  id='demo-simple-select-outlined'
                  value={iconTypeState[key][0]}
                  onChange={evt => {
                    handleIconTypeChange(key, evt.target.value);
                  }}
                  labelWidth={labelWidth}
                >
                  <MenuItem value='all'>All</MenuItem>
                  {value.details.map(icon => {
                    return <MenuItem value={icon.id}>{icon.iconType}</MenuItem>;
                  })}
                </Select>
              </FormControl>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <Button
                className='icon-button'
                disabled={
                  iconTypeState[key][0] === '' || fileTypeState[key][0] === ''
                }
                variant='contained'
                onClick={() => updateIcon(subPack, key, value)}
              >
                Add to My Icons
              </Button>
              <Button
                className='icon-button'
                disabled={
                  iconTypeState[key][0] === '' ||
                  fileTypeState[key][0] === '' ||
                  iconTypeState[key][0] === 'all'
                }
                variant='contained'
                onClick={() => {
                  copyURL(subPack, key);
                }}
              >
                {copied ? 'Copied' : 'Copy URL'}
              </Button>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default IconGroups;



// WEBPACK FOOTER //
// ./src/js/subcategory/iconGroups.js